module.exports = __webpack_public_path__ + "img/icon-chart-bar.c02e5322.svg";